import { ClientApi } from "@/api/ClientApi";
import { ZoneApi } from "@/api/ZoneApi";
import { SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { STATUS_FILTER } from "@utils/Constants";
import { isEmpty } from "@utils/Utils";

const ClientStatusFormConfig = {
    sections: [
        {
            "fields": [
                [
                    {
                        "type": "text",
                        "name": "client_code",
                        "exludeFromSubmit": true,
                        "isHorizontal": true,
                        "label": "Codigo Cliente",
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 2
                            }
                        }
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "clientId",
                        "label": "Cliente",
                        "isHorizontal": true,
                        "optionsFunction": async () => {
                            const clients = await ClientApi.optionsList();
                            return {
                                "-2": " Todos los clientes",
                                ...clients
                            }
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 9
                        },
                        "validation": Yup.string().when("zoneId", {
                            is: (zoneId: unknown) => isEmpty(zoneId),
                            then: (s) => s.required("Seleccione ya sea un cliente o una zona de clientes"),
                            otherwise: (s) => s.notRequired(),
                        }),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "zoneId",
                        "label": "Zona de Cliente",
                        "optionsFunction": async () => {
                            const zones = await ZoneApi.optionsList();
                            return {
                                "-2": " Todos las zonas",
                                ...zones
                            }
                        },
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        }
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "kind",
                        "label": "Tipo de Filtro",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "options": STATUS_FILTER,
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "date",
                        "name": "endDate",
                        "label": "Proyeccion a Fecha",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
            ]
        }
    ],
};


export default ClientStatusFormConfig;